import axios from 'axios'
import QueryParamsUtil from 'api/utils/query-params-util'

const API_PATH = 'api/v2/admins/products/attributes'

const ProductAttributesApiV2 = {
  /**
   * Get curation attributes by given product category id
   * @param {number} category_id Product Category ID
   */
  getCurationAttributes: async (category_id) => {
    const path   = `${API_PATH}/curation`
    const params = {
      category_id: category_id
    }

    const response = axios.get(path, { params })
    return response
  },

  /**
   * Get all Product Attribute curation options from particular attribute code
   * @param {string} attributeCode attribute code from Product Attribute
   */
  getCurationOptions: async ({ attributeCode }) => {
    const path = `${API_PATH}/${attributeCode}/options/curation`

    const response = axios.get(path)
    return response
  },

  /**
   * Get all Product Attribute options from particular attribute code
   * @param {string} attributeCode attribute code from Product Attribute
   */
  getOptions: async ({ attributeCode, tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = `${API_PATH}/${attributeCode}/options`

    const response = axios.get(path, { params })
    return response
  },

  /**
   * Create Product Attribute option from particular attribute code
   * @param {string} attribute_code attribute code from Product Attribute
   * @param {object} payload payload object
   */
  create: async ({ attribute_code, payload }) => {
    const path = `${API_PATH}/${attribute_code}/options`
    const body = payload

    const response = axios.post(path, body)
    return response
  },

  /**
   * Enable a particular Product Attribute option from particular attribute code
   * @param {string} attribute_code attribute code from Product Attribute
   * @param {number} id id of the Product Attribute
   */
  enableOption: async (attribute_code, id) => {
    const path = `${API_PATH}/${attribute_code}/options/${id}/enable`

    const response = axios.patch(path)
    return response
  },

  /**
   * Disable a particular Product Attribute option from particular attribute code
   * @param {string} attribute_code attribute code from Product Attribute
   * @param {number} id id of the Product Attribute
   */
  disableOption: async (attribute_code, id) => {
    const path = `${API_PATH}/${attribute_code}/options/${id}/disable`

    const response = axios.patch(path)
    return response
  }
}

export default ProductAttributesApiV2
